import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import "../../css/ListUsers.css";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import DelegateAppSurveyReadOnlyRow from "../../components/DelegateAppSurveyReadOnlyRow";
import DelegateAppSurveyTableRow from "../../components/DelegateAppSurveyTableRow";


function ListDelegateAppSurveys({ indirectBuyerKey, buyerKey, partnershipKey, selectedDelegate, level, setAppSurvey }) {
    const navigate = useNavigate();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [edit, setEdit] = useState(false);

    const [errorValue, setErrorValue] = useState("");
    const [delegateAppSurveys, setDelegateAppSurveys] = useState([]);
    const [editableRecord, setEditableRecord] = useState({});
    const [count, setCount] = useState(0);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchDelegateAppSurvey();
    }, []);

    const initialValues = {
        surveyDelegateKey: 0,
        appSurveyKey: 0,
        buyerKey: buyerKey,
        companyKey: 0,
        indirectBuyerKey: indirectBuyerKey,
        canWrite: 0,
        canReview: 0,
        canRead: 0,
        onlyReadMediumHighScore: 0,
        statusCode: 1,
        level: level,
        delegateKey: 0,
        partnershipKey: partnershipKey,
    };

    const [editFormData, setEditFormData] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };
    function fetchDelegateAppSurvey() {
        setErrorValue("");
        if ((!indirectBuyerKey || indirectBuyerKey === 0)) {
            setErrorValue(t("error.indirectBuyer.Reqd"));
            return;
        }
        if ((!buyerKey || buyerKey == 0)) {
            setErrorValue(t("error.buyer.Reqd"));
            return;
        }
        if ((!selectedDelegate.companyId || selectedDelegate.companyId == 0)) {
            setErrorValue(t("error.suplrReqd"));
            return;
        }
        setIsLoading(true);
        resetCounter();
        let serverParams = {
            source: "web", getAll: true,
            indirectBuyerKey: indirectBuyerKey,
            buyerKey: buyerKey,
            companyKey: selectedDelegate.companyId,
            level: level,
        };
        //console.log("fetchAppSurvey: " + JSON.stringify(serverParams));
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };
        try {
            FetchUtil.fetchAPI("GetDelegateAppSurveys", "/Service/CompanyService/GetDelegateAppSurveys", requestOptions, fetchDelegateAppSurveySuccess, fetchDelegateAppSurveyFail);
        } catch (error) {
            setIsLoading(false);
            throw new Error(error.message);
        }
    }

    function fetchDelegateAppSurveyFail(redirect) {
        setIsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.delegateAppSurveyNotRetrieved"));
    }

    function fetchDelegateAppSurveySuccess(responseData) {
        let getDelegateAppSurveyResponse;
        if (responseData) {
            getDelegateAppSurveyResponse = responseData.getDelegateAppSurveyResponse;
            if (getDelegateAppSurveyResponse && getDelegateAppSurveyResponse.errorCode === "0") {
                if (getDelegateAppSurveyResponse.appSurveys) {
                    setDelegateAppSurveys([...getDelegateAppSurveyResponse.appSurveys]);
                } else {
                    setDelegateAppSurveys([]);
                }
            } else if (getDelegateAppSurveyResponse && getDelegateAppSurveyResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getDelegateAppSurveyResponse) {
                setErrorValue(t("error.error") + " " + getDelegateAppSurveyResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
        setIsLoading(false);
    }

    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };

    const addRowTable = () => {
        setErrorValue("");
        if (!add && !edit) {
            setAdd(true);
        } else {
            if (add) {
                setErrorValue(t("error.only1RowAllowed"));
            } else if (edit) {
                setErrorValue(t("error.onlyEditAllowed"));
            }
        }
    };
    const removeRowTable = () => {
        setErrorValue("");
        resetRowTable();
        setIsLoading(false);
    };
    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
        setEdit(false);
    };
    const handleClose = () => {
        setErrorValue("");
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
        setEdit(false);
        setAppSurvey(false);
    }
    const handleEditClick = (event, delegateAppSurveyItem, completeCallback) => {
        event.preventDefault();
        setErrorValue("");
        if (!add && !edit) {
            setEdit(true);
            setEditableRecord(delegateAppSurveyItem);
        } else {
            if (add) {
                setErrorValue(t("error.newRowAdded"));
            } else if (edit) {
                setErrorValue(t("error.onlyEditAllowed"));
            }
        }
    };
    const handleDeleteClick = (event, delegateAppSurveyItem, completeCallback) => {
        event.preventDefault();
        setErrorValue("");
        deleteDelegateAppSurvey(delegateAppSurveyItem, completeCallback);
    };

    const deleteDelegateAppSurvey = (delegateAppSurveyItem, completeCallback) => {
        let action = 3;
        if (delegateAppSurveyItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            surveyDelegateKey: delegateAppSurveyItem.surveyDelegateKey,
            statusCode: delegateAppSurveyItem.statusCode,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };
        try {
            FetchUtil.fetchAPI("DeleteDelegateAppSurvey", "/Service/CompanyService/DeleteDelegateAppSurvey", requestOptions, deleteDelegateAppSurveySuccess, deleteDelegateAppSurveyFail, completeCallback);
        } catch (error) {
            setErrorValue(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    }

    function deleteDelegateAppSurveyFail(redirect, completeCallback) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.delegateAppSurveyDeleteFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deleteDelegateAppSurveySuccess(responseData, completeCallback) {
        let deleteDelegateAppSurveyResponse;
        if (responseData) {
            deleteDelegateAppSurveyResponse = responseData.deleteDelegateAppSurveyResponse;
            if (deleteDelegateAppSurveyResponse && deleteDelegateAppSurveyResponse.errorCode === "0") {
                resetRowTable();
                fetchDelegateAppSurvey();
            } else if (deleteDelegateAppSurveyResponse && deleteDelegateAppSurveyResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else {
                setErrorValue(t("error.error") + " " +
                    deleteDelegateAppSurveyResponse.errorMessage
                );
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    const handleSubmit = (action, setValues, completeCallback) => {
        setErrorValue("");
        let found = false;
        if (action === 2) {
            editFormData.surveyDelegateKey = setValues.surveyDelegateKey;
        } else {
            editFormData.surveyDelegateKey = 0;
        }

        editFormData.companyKey = setValues.companyKey;
        editFormData.appSurveyKey = setValues.appSurveyKey;
        editFormData.canWrite = setValues.canWrite;
        editFormData.canReview = setValues.canReview;
        editFormData.canRead = setValues.canRead;
        editFormData.onlyReadMediumHighScore = setValues.onlyReadMediumHighScore;
        editFormData.delegateKey = setValues.delegateKey;

        if (!editFormData.companyKey || editFormData.companyKey == 0) {
            setErrorValue(t("error.companyReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!buyerKey || buyerKey == 0) {
            setErrorValue(t("error.buyer.Reqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!indirectBuyerKey || indirectBuyerKey == 0) {
            setErrorValue(t("error.indirect.buyer.Reqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!editFormData.appSurveyKey || editFormData.appSurveyKey == 0) {
            setErrorValue(t("error.appSurveyNameReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (delegateAppSurveys.length > 0) {
                delegateAppSurveys.map((delegateAppSurvey, index) => {
                    if (delegateAppSurvey.companyId === editFormData.companyKey
                        && delegateAppSurvey.buyerKey === buyerKey
                        && delegateAppSurvey.indirectBuyerKey === indirectBuyerKey
                        && delegateAppSurvey.appSurveyKey === editFormData.appSurveyKey
                        && delegateAppSurvey.delegateKey === editFormData.delegateKey) {
                        setErrorValue(t("error.delegateAppSurveyDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveDelegateAppSurvey(action, completeCallback);
            }
        } else if (action === 2) {
            if (!editFormData.surveyDelegateKey) {
                setErrorValue(t("error.surveyDelegateKey.Reqd"));
                if (completeCallback) {
                    completeCallback();
                }
                return false;
            }
            if (delegateAppSurveys.length > 0) {
                delegateAppSurveys.map((delegateAppSurvey, index) => {
                    if (delegateAppSurvey.companyId === editFormData.companyKey
                        && delegateAppSurvey.buyerKey === buyerKey
                        && delegateAppSurvey.indirectBuyerKey === indirectBuyerKey
                        && delegateAppSurvey.appSurveyKey === editFormData.appSurveyKey
                        && delegateAppSurvey.delegateKey === editFormData.delegateKey) {
                        if (delegateAppSurvey.surveyDelegateKey !== editFormData.surveyDelegateKey) {
                            setErrorValue(t("error.delegateAppSurveyDup"));
                            found = true;
                            if (completeCallback) {
                                completeCallback();
                            }
                            return false;
                        } else if (delegateAppSurvey.surveyDelegateKey == editFormData.surveyDelegateKey
                            && delegateAppSurvey.canRead == editFormData.canRead
                            && delegateAppSurvey.canWrite == editFormData.canWrite
                            && delegateAppSurvey.canReview == editFormData.canReview
                            && delegateAppSurvey.onlyReadMediumHighScore == editFormData.onlyReadMediumHighScore) {
                            found = true;
                            if (completeCallback) {
                                completeCallback();
                            }
                            return false;
                        }
                    }
                })
            }
            if (!found) {
                saveDelegateAppSurvey(action, completeCallback);
            }
        }
    };
    const saveDelegateAppSurvey = (action, completeCallback) => {
        let serverParams = {
            surveyDelegateKey: editFormData.surveyDelegateKey,
            companyId: editFormData.companyKey,
            buyerKey: buyerKey,
            indirectBuyerKey: indirectBuyerKey,
            appSurveyKey: editFormData.appSurveyKey,
            canRead: editFormData.canRead,
            canWrite: editFormData.canWrite,
            canReview: editFormData.canReview,
            onlyReadMediumHighScore: editFormData.onlyReadMediumHighScore,
            delegateKey: editFormData.delegateKey,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateDelegateAppSurvey", "/Service/CompanyService/AddUpdateDelegateAppSurvey", requestOptions, saveDelegateAppSurveySuccess, saveDelegateAppSurveyFail, completeCallback);
        } catch (error) {
            setErrorValue(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function saveDelegateAppSurveyFail(redirect, completeCallback) {
        setErrorValue(t("error.delegateAppSurveySaveFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function saveDelegateAppSurveySuccess(responseData, completeCallback) {
        let addUpdateDelegateAppSurveyResponse;
        if (responseData) {
            addUpdateDelegateAppSurveyResponse = responseData.addUpdateDelegateAppSurveyResponse;
            if (addUpdateDelegateAppSurveyResponse) {
                if (addUpdateDelegateAppSurveyResponse.errorCode === "0") {
                    resetRowTable();
                    fetchDelegateAppSurvey();
                } else if (addUpdateDelegateAppSurveyResponse.errorCode === "114") {
                    navigate("/", {
                        state: {
                            errorMessage: t("error.sessionTimeout"),
                        },
                    });
                } else {
                    setErrorValue(t("error.error") + " " +
                        addUpdateDelegateAppSurveyResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    return (
        <>
            {(userCtx.role === "SiteAdmin") ?
                <div className="modalContainer-sm hide-scrollbar">
                    <div className="row">
                        <div className="col">
                            <h5 style={{ marginLeft: "2vw", textAlign: 'center' }}><b><span style={{ fontSize: "18px" }}></span>{t("header.admin.partnerDelegateAppSurvey")}</b></h5>
                        </div>
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mt-3">
                            <div
                                id="inerrorMessage"
                                className={
                                    (errorValue) ? "errorblock" : "errorblock hide"
                                }
                            >
                                {errorValue ? errorValue : ""}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.secondarySupplierName")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.survey.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.read")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.write")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.review")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.read.medhigh")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {add && addRowTop &&
                                        <DelegateAppSurveyTableRow
                                            index={count}
                                            selectedDelegate={selectedDelegate}
                                            primaryBuyerCompanyId={buyerKey}
                                            secondaryBuyerCompanyId={indirectBuyerKey}
                                            delegateAppSurveyItem={{}}
                                            handleSubmit={handleSubmit}
                                            setError={setErrorValue}
                                            t={t}
                                            setAdd={setAdd}
                                            setEdit={setEdit}
                                            oddIdx={((delegateAppSurveys.length % 2) > 0) ? true : false} />
                                    }
                                    {delegateAppSurveys.length > 0 && (
                                        delegateAppSurveys.map((delegateItem, index) => (
                                            ((edit && delegateItem.surveyDelegateKey === editableRecord.surveyDelegateKey) ?
                                                <DelegateAppSurveyTableRow
                                                    index={count}
                                                    selectedDelegate={selectedDelegate}
                                                    primaryBuyerCompanyId={buyerKey}
                                                    secondaryBuyerCompanyId={indirectBuyerKey}
                                                    delegateAppSurveyItem={editableRecord}
                                                    handleSubmit={handleSubmit}
                                                    setError={setErrorValue}
                                                    t={t}
                                                    setAdd={setAdd}
                                                    setEdit={setEdit}
                                                    edit={edit}
                                                    oddIdx={((delegateAppSurveys.length % 2) > 0) ? true : false} />
                                                :
                                                <DelegateAppSurveyReadOnlyRow
                                                    index={count}
                                                    t={t}
                                                    delegateItem={delegateItem}
                                                    handleDeleteClick={handleDeleteClick}
                                                    handleEditClick={handleEditClick}
                                                    oddIdx={((index % 2) > 0) ? true : false}
                                                    setError={setErrorValue}
                                                />
                                            )
                                        ))
                                    )}
                                    {add && addRowBottom &&
                                        <DelegateAppSurveyTableRow
                                            index={count}
                                            selectedDelegate={selectedDelegate}
                                            primaryBuyerCompanyId={buyerKey}
                                            secondaryBuyerCompanyId={indirectBuyerKey}
                                            delegateAppSurveyItem={{}}
                                            handleSubmit={handleSubmit}
                                            setError={setErrorValue}
                                            t={t}
                                            setAdd={setAdd}
                                            setEdit={setEdit}
                                            oddIdx={((delegateAppSurveys.length % 2) > 0) ? true : false} />
                                    }
                                </tbody>
                                {(delegateAppSurveys.length > 10) ? (<tfoot>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.secondarySupplierName")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.survey.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.read")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.write")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.review")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.read.medhigh")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </tfoot>
                                ) : (<></>)}
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mt-3">
                            <div
                                id="berrorMessage"
                                className={
                                    (errorValue) ? "errorblock" : "errorblock hide"
                                }
                            >
                                {errorValue ? errorValue : ""}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_2" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="footer">
                        <input
                            type="button"
                            name="delegate-appsurvey-close"
                            id="delegate-appsurvey-close"
                            className="btn btn-secondary btn-block" data-dismiss="modal"
                            onClick={(e) => handleClose()}
                            style={{ marginTop: "10px", marginBottom: "10px" }}
                            value={t("page.close")}
                        ></input>
                    </div>
                </div>
                : null}
        </>
    );
}

export default ListDelegateAppSurveys;